<script>
  import { taxi, praxi, planetIndex } from "../js/stores.js"

  $: if ($taxi) {
    // console.log($taxi)
    plausible("Τάξεις", { props: { Τάξη: $taxi } })
  }

  // $: if ($planetIndex > 2) {
  //   plausible("Planets", { props: { planet: $planetIndex } })
  // }

  $: if ($taxi && $praxi) {
    // console.log($praxi)
    plausible("Πράξεις", { props: { Πράξη: $praxi } })
  }
  // $: if ($taxi) console.log("taxi :>> ", $taxi)

  // Οι τερματισμοί και το score καταγράφονται στο FinaleScore component
</script>
